import React, { useRef } from 'react';
import ReactTagsInput from "react-tagsinput";
import SVGInline from "react-svg-inline";

import CloseIcon from '../../../images/close.svg';

import { Input, Tag, CloseButton, InputContainer } from './style'
import { callAllFunction } from '../../..';

export const TagsInput = ({ 
    containerProps, 
    inputProps, 
    tagProps, 
    delimiters, 
    children, 
    renderTag, 
    getTagStyle,
    getTagClassName, 
    ...rest 
}) => {

    const inputRef = useRef();
    const containerRef = useRef();
    const defaultPasteSplit = (data) => {
        const regex = new RegExp(delimiters.join('|'))
        return data.split(regex).map((d) => d.trim());
    };


    const onFocusContainer = () => {
        inputRef.current && inputRef.current.focus();
        containerRef.current && containerRef.current.classList.add("focus");
    }

    const defaultRenderTag = (props) => {
        const { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, style, className, ...other } = props;
        const value = getTagDisplayValue(tag);
        const tagStyle = typeof getTagStyle === 'function' ? getTagStyle(value) : {};
        const combinedStyle = {...(style||{}) , ...tagStyle};

        const tagClassName = typeof getTagClassName === 'function' ? getTagClassName(value) : '';
        const combinedClassName = `${className} ${tagClassName}`
        return (
            <Tag key={key} style={combinedStyle} className={combinedClassName} {...other} {...tagProps}>
                {value}
                {!disabled &&
                    <CloseButton className={classNameRemove} onClick={(e) => onRemove(key)} >
                        <SVGInline
                            svg={CloseIcon}
                        />
                    </CloseButton>
                }
            </Tag>
        )
    }

    const onInputBlur = () => {
        containerRef.current && containerRef.current.classList.remove("focus");
    }

    const defaultRenderInput = (props) => {
        const { addTag, onBlur, ...rest } = props;
        const myBlur = callAllFunction(onBlur, onInputBlur)
        return (
            <Input
                type="text"
                {...rest}
                {...inputProps}
                onBlur={myBlur}
            />
        );
    };

    const defaultRenderLayout = (tagComponents, inputComponent) => {
        return (
            <InputContainer ref={containerRef} onClick={onFocusContainer} {...containerProps}>
                {tagComponents}
                {inputComponent}
                {children}
            </InputContainer>
        );
    };

    return (
        <ReactTagsInput
            ref={inputRef}
            addKeys={[...delimiters, 32, 9, 13]} // 32 -> space key, 13 -> enter key, 9 -> tab key
            renderTag={defaultRenderTag}
            renderInput={defaultRenderInput}
            pasteSplit={defaultPasteSplit}
            renderLayout={defaultRenderLayout}
            addOnPaste={true}
            {...rest}
        />
    )
}

TagsInput.defaultProps = {
    delimiters: [","],
    getTagStyle: null,
    getTagClassName: null
};